import { useCallback } from 'react'
import { useAppSelector, useAppDispatch} from '../redux/hook'
import { ApplicationStart } from '../models/classes/ApplicationStart.class';
import { ApplicationStep1 } from '../models/classes/ApplicationStep1.class';
import { ApplicationStep3 } from '../models/classes/ApplicationStep3.class';
import { ApplicationStep2 } from '../models/classes/ApplicationStep2.class';
import { ApplicationStep4 } from '../models/classes/ApplicationStep4.class';
import { ApplicationStep5 } from '../models/classes/ApplicationStep5.class';
import { CooSubmission } from '../models/classes/CooSubmission.class';
import { setApplicationId } from '../redux/slices/application-id-slice';
import { updateFormData as updateFormDataStart } from '../redux/slices/application-start-slice'
import { HoldingFormData } from '../models/polymer/HoldingFormData.model';
import { convertPolymerStageToStep, convertStepToPolymerStage } from '../utils/polymer-stage-converter';

function useSaveDraft() {
  const uinfin = useAppSelector(state => state.auth.AuthenticationSlice.loginUser.uinfin);
  const start_application = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const application_step_1 = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const application_step_2 = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const application_step_3 = useAppSelector(state => state.app.ApplicationStep3Slice.formData);
  const application_step_4 = useAppSelector(state => state.app.ApplicationStep4Slice.formData);
  const application_step_5 = useAppSelector(state => state.app.ApplicationStep5Slice.formData);
  
  const AppDispatch = useAppDispatch();
  const performSaveDraft = useCallback(async(form_value:ApplicationStart | ApplicationStep1 | ApplicationStep2 | ApplicationStep3 | ApplicationStep4 | ApplicationStep5, step:number, applicationId?: string, singpassToken?:string): Promise<boolean>=>{
    const currentStep = convertPolymerStageToStep(start_application.polymer_stage);
    const newPolymerStage = convertStepToPolymerStage(Math.max(currentStep, step));

    const newStartForm = new ApplicationStart({...start_application, polymer_stage: newPolymerStage});
    AppDispatch(updateFormDataStart(newStartForm));
    
    let cooObj = new CooSubmission();
    cooObj.setMainApplicantUinfin(loginUser.uinfin ?? ""); //No issue for decryption and encryption
    cooObj.setApplicationStartForm(step === 0 ? form_value as ApplicationStart : start_application);  //No issue for decryption and encryption
    cooObj.setApplicationStep1Form(step === 1 ? form_value as ApplicationStep1 : application_step_1); //No issue for decryption and encryption
    cooObj.setApplicationStep2Form(step === 2 ? form_value as ApplicationStep2 : application_step_2); //No issue for decryption and encryption
    cooObj.setApplicationStep3Form(step === 3 ? form_value as ApplicationStep3 : application_step_3); //No issue for decryption and encryption
    cooObj.setApplicationStep4Form(step === 4 ? form_value as ApplicationStep4 : application_step_4); //No issue for decryption and encryption
    cooObj.setApplicationStep5Form(step === 5 ? form_value as ApplicationStep5 : application_step_5); //No issue for decryption and encryption
    cooObj.mapMainApplicantToOwnerSaveDraft(start_application); //No issue for decryption and encryption


    const response = await cooObj.performSaveDraft(uinfin, newPolymerStage, applicationId, singpassToken);
    if(response.application_id){
        AppDispatch(setApplicationId(response.application_id));
    }
    return response.success;
    
  },[loginUser.uinfin, start_application, application_step_1, application_step_2, application_step_3, application_step_4, application_step_5, uinfin, AppDispatch]);
  
  interface SaveDraftManual {
    applicationStart:ApplicationStart, 
    applicationStep1: ApplicationStep1, 
    applicationStep2: ApplicationStep2, 
    applicationStep3: ApplicationStep3, 
    applicationStep4: ApplicationStep4, 
    applicationStep5: ApplicationStep5, 
    applicationId?: string, 
    singpassToken?:string, 
    holdingFormValues?:HoldingFormData
  }

  const performSaveDraftManual = useCallback(async(SaveDraftManual: SaveDraftManual, step: number): Promise<boolean>=>{
    const {applicationStart, applicationStep1, applicationStep2, applicationStep3, applicationStep4, applicationStep5, applicationId, singpassToken, holdingFormValues} = SaveDraftManual;
    
    let cooObj = new CooSubmission();
    cooObj.setMainApplicantUinfin(loginUser.uinfin ?? "");
    cooObj.setApplicationStartForm(applicationStart);
    cooObj.setApplicationStep1Form(applicationStep1);
    cooObj.setApplicationStep2Form(applicationStep2);
    cooObj.setApplicationStep3Form(applicationStep3);
    cooObj.setApplicationStep4Form(applicationStep4);
    cooObj.setApplicationStep5Form(applicationStep5);
    cooObj.mapMainApplicantToOwnerSaveDraft(start_application, holdingFormValues); //No issue for decryption and encryption

    const polymerStage = convertStepToPolymerStage(step)

    const response = await cooObj.performSaveDraft(uinfin, polymerStage, applicationId, singpassToken);
    if(response.application_id){
        AppDispatch(setApplicationId(response.application_id));
    }
    return response.success;
    
  },[loginUser.uinfin, start_application, uinfin, AppDispatch]);

  return { performSaveDraft, performSaveDraftManual }
 
}
export default useSaveDraft